const moduleRoute = {
  path: '/financeiro',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: '',
      component: () => import('./views/Home.vue'),
      children: [
        { path: '', component: () => import('./views/Dashboard.vue') },
        { path: 'dashboard', component: () => import('./views/Dashboard.vue') },
        {
          path: 'fluxo_de_caixa',
          component: () => import('./views/Cashflow.vue')
        },
        {
          path: 'contas_a_receber',
          component: () => import('./views/BillsToReceive.vue')
        },
        {
          path: 'contas_a_pagar',
          component: () => import('./views/BillsToPay.vue')
        },
        {
          path: 'movimentacoes',
          component: () => import('./views/Movements.vue')
        },
        {
          path: 'transacoes',
          component: () => import('./views/Transactions.vue')
        },
        {
          path: 'conciliacao',
          component: () => import('./views/Reconciliation/index.vue'),
          children: [
            {
              path: '',
              name: 'financial-conciliacao',
              component: () => import('./views/Reconciliation/Choice.vue')
            },
            {
              path: 'manual',
              name: 'financial-conciliacao-manual',
              component: () => import('./views/Reconciliation/Manual.vue'),
              children: [
                {
                  path: '',
                  redirect: 'pending'
                },
                {
                  path: 'pending',
                  name: 'financial-conciliacao-manual-pending',
                  component: () =>
                    import(
                      './views/Reconciliation/Components/TransactionsTable.vue'
                    )
                },
                {
                  path: 'reconciled',
                  name: 'financial-conciliacao-manual-reconciled',
                  component: () =>
                    import(
                      './views/Reconciliation/Components/TransactionsTable.vue'
                    )
                },
                {
                  path: 'archived',
                  name: 'financial-conciliacao-manual-archived',
                  component: () =>
                    import(
                      './views/Reconciliation/Components/TransactionsTable.vue'
                    )
                }
              ]
            },
            {
              path: 'automatica',
              name: 'financial-conciliacao-automatica',
              component: () => import('./views/Reconciliation/Automatic.vue')
            },
            {
              path: 'arquivados',
              name: 'financial-conciliacao-arquivados',
              component: () =>
                import('./views/Reconciliation/ArchivedEntriesGlobal.vue')
            }
          ]
        },
        {
          path: 'favorecidos',
          component: () => import('./views/Beneficiaries.vue')
        },
        {
          path: 'credito_paciente',
          component: () => import('./views/PatientCredit.vue')
        },
        {
          path: 'configuracoes',
          component: () => import('./views/Configurations.vue')
        }
      ]
    },
    {
      path: 'pendings',
      component: () => import('./views/PendingHome.vue'),
      children: [
        {
          path: 'dashboard',
          component: () => import('./views/PendingDashboard.vue')
        },
        {
          path: 'history',
          component: () => import('./views/PendingHistory.vue')
        }
      ]
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
